import { Schema } from 'effect';
import type { SortDescriptor } from 'react-aria-components';

import { UserOrderBy } from '../../../../../../generated/types';

export const USER_SORT_COLUMNS = ['id', 'created', 'user', 'accounts', 'role'] as const;

export type UserSortColumn = (typeof USER_SORT_COLUMNS)[number];

export type UserSort = {
  readonly column: UserSortColumn;
  readonly direction: 'ascending' | 'descending';
};

export const DEFAULT_USER_SORT: UserSort = { column: 'id', direction: 'descending' };

const byId = { ascending: UserOrderBy.RowIdAsc, descending: UserOrderBy.RowIdDesc };

const orderByColumn = {
  id: byId,
  created: byId,
  user: { ascending: UserOrderBy.EmailAsc, descending: UserOrderBy.EmailDesc },
  accounts: { ascending: UserOrderBy.AccountTotalAsc, descending: UserOrderBy.AccountTotalDesc },
  role: { ascending: UserOrderBy.RoleAsc, descending: UserOrderBy.RoleDesc },
} as const satisfies Record<UserSortColumn, Record<UserSort['direction'], UserOrderBy>>;

const isUserSortColumn = Schema.is(Schema.Literals(USER_SORT_COLUMNS));

export const userOrderBy = (sort: UserSort): UserOrderBy =>
  orderByColumn[sort.column][sort.direction];

export const userSorting = (sort: UserSort, onChange: (sort: UserSort) => void) => ({
  sortableColumns: USER_SORT_COLUMNS,
  sortDescriptor: { column: sort.column, direction: sort.direction },
  onSortChange: (descriptor: SortDescriptor) => {
    if (!isUserSortColumn(descriptor.column)) return;
    onChange({ column: descriptor.column, direction: descriptor.direction });
  },
});
